import React, { Suspense, lazy, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getPuntosControl,
  configuracionEvento,
  eventSubEvents,
  juecesEvento,
  resultadosEventoNew,
} from "../../../data-store/actions/events-actions";
import {
  eventParticipants,
  registryConfiguration,
  registryAutorizedUsers,
} from "../../../data-store/actions/registry-actions";

import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import DownloadResultsButton from "../../Landing/sections/RaceResultsPublic/PastReports/reports/DownloadResultsButton";
import { Grid, CircularProgress, Box } from "@material-ui/core";
// Dashboard se queda como import normal (no lazy): es el tab que se ve por
// defecto al abrir esta pantalla, así que da igual — siempre hay que
// cargarlo de una, y lazy solo le agregaría un parpadeo de "Cargando..."
// sin ahorrar nada.
import DashboardTimingContainer from "./Timing/DashboardTiming/DashboardTimingContainer";
import StartsList from "./Timing/TimingRegistry/StartsList";

// El resto de los tabs (Ganadores, Real Time, Subclasificaciones, etc.) no
// se ven hasta que el usuario hace clic en ellos — con import normal, su
// código (y el de sus propias dependencias, ej. el editor de canvas que
// usan otras pantallas de este mismo árbol) ya viaja en el mismo bundle
// que el Dashboard desde el primer render. Con React.lazy, cada uno se
// separa en su propio archivo .js que solo se descarga la primera vez que
// se abre ese tab específico.
const ResultsReportNewAUTH = lazy(() => import("../reports/ResultsReportNewAUTH"));
const SubclasificacionesReport = lazy(() => import("../reports/SubclasificacionesReport"));
const RealTimeResults = lazy(() => import("../reports/RealTimeResults"));
const Anouncer = lazy(() => import("../reports/Anouncer"));
const UploadResultsData = lazy(() => import("./UploadResultsData"));
const EventClock = lazy(() => import("../reports/EventClock/EventClock"));
const CustomViewContainer = lazy(() => import("./CustomViews/CustomViewsContainer.jsx"));
const CustomViewContainerNew = lazy(() => import("./CustomViews/CustomViewsContainerNew"));
const PhotoGalleryView = lazy(() => import("./PhotosEvent/PhotoGalleryView"));
const DistancesFilter = lazy(() => import("./Timing/DistancesFilter"));
const KilometrosTotales = lazy(() => import("./Timing/KilometrosTotales/KilometrosTotales"));

function TabLoading() {
  return (
    <Box display="flex" justifyContent="center" p={4}>
      <CircularProgress />
    </Box>
  );
}

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function AuthorizedUsersResultsContainerNew({ match }) {
  const { EventoIndex } = match.params;

  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);

  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventSubEvents1 = useSelector((state) => state.events.eventSubEvents);
  const eventResults = useSelector((state) => state.events.eventResults);
  const eventConfiguration = useSelector(
    (state) => state.events.eventConfiguration
  );
  const puntosControl = useSelector((state) => state.events.puntosControl);
  const eventUsers = useSelector((state) => state.events.eventUsers);

  const [value, setValue] = useState(0);
  const [codMod, setCodMod] = useState(null);
  const [codCat, setCodCat] = useState(null);
  const [gen, setGen] = useState(null);
  console.log("value", value);
  console.log(eventDetail.iDEvento, EventoIndex);

  useEffect(() => {
    if (!validateProps() || "evento_" + eventDetail.iDEvento !== EventoIndex) {
      dispatch(resultadosEventoNew(EventoIndex));

      dispatch(configuracionEvento(EventoIndex));
      dispatch(getPuntosControl(EventoIndex));
      dispatch(eventSubEvents(EventoIndex));
      dispatch(juecesEvento(EventoIndex));
    }
  }, []);

  function handleChange(event, value) {
    setValue(value);
  }
  function validateProps() {
    // para validar que todos los datos requeridos ya se descargaron para continuar
    //
    // OJO con eventSubEvents1: el estado inicial de Redux lo define como
    // {} (no null/undefined, ver configureStore.js) — a diferencia de
    // eventResults/eventConfiguration/eventUsers/puntosControl, que sí
    // arrancan undefined. Eso significa que el check "!== null/undefined"
    // por sí solo YA pasa desde el primer render, antes de que Firebase
    // responda; si la respuesta real de eventSubEvents tarda más que las
    // otras, la página terminaba renderizándose completa con las
    // modalidades vacías (ej. el tab Dashboard sin el desglose por
    // distancia). Por eso acá también se exige que tenga contenido real.
    if (
      eventResults !== null &&
      eventResults !== undefined &&
      eventSubEvents1 !== null &&
      eventSubEvents1 !== undefined &&
      Object.keys(eventSubEvents1).length > 0 &&
      eventConfiguration !== null &&
      eventConfiguration !== undefined &&
      eventUsers !== null &&
      eventUsers !== undefined &&
      puntosControl !== null &&
      puntosControl !== undefined
    ) {
      return true;
    }
    return false;
  }

  let arrayTabs = [];
  let contentTabs = [];

  let userProfile = null;
  var convocatoriaShow;
  var tabConfig;

  arrayTabs.push(<Tab key="tab-Dashboard" label="Dashboard" />);
  contentTabs.push(
    <TabContainer key="contTab-Dashboard">
      <DashboardTimingContainer />
    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-Ganadores" label="Ganadores" />);
  contentTabs.push(
    <TabContainer key="contTab-Ganadores">
      <DistancesFilter eventSubEvents={eventSubEvents1} onButtonClick={setCodMod} codMod={codMod} />
      <ResultsReportNewAUTH
        reportResultType={4}
        controles={true}
        puntosControl={puntosControl}
        codMod={codMod}
        gen={gen}
        codCat={codCat}
      />
    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-Categorias" label="Categorías" />);
  contentTabs.push(
    <TabContainer key="contTab-Categorias">
      <DistancesFilter eventSubEvents={eventSubEvents1} onButtonClick={setCodMod} codMod={codMod} />
      <ResultsReportNewAUTH
        reportResultType={3}
        controles={true}
        puntosControl={puntosControl}
        codMod={codMod}
        gen={gen}
        codCat={codCat}
      />
    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-Rama" label="Rama" />);
  contentTabs.push(
    <TabContainer key="contTab-Rama">
      <DistancesFilter eventSubEvents={eventSubEvents1} onButtonClick={setCodMod} codMod={codMod} />
      <ResultsReportNewAUTH
        reportResultType={2}
        controles={true}
        puntosControl={puntosControl}
        codMod={codMod}
        gen={gen}
        codCat={codCat}
      />

    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-Generales" label="Generales" />);
  contentTabs.push(
    <TabContainer key="contTab-Generales">
      <DistancesFilter eventSubEvents={eventSubEvents1} onButtonClick={setCodMod} codMod={codMod} />
      <ResultsReportNewAUTH
        reportResultType={1}
        controles={true}
        puntosControl={puntosControl}
        codMod={codMod}
        gen={gen}
        codCat={codCat}

      />

    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-Subclasificaciones" label="Subclasificaciones" />);
  contentTabs.push(
    <TabContainer key="contTab-Subclasificaciones">
      <SubclasificacionesReport />
    </TabContainer>
  );
  // Ya existe también dentro de "Fotos Evento (Beta)" — se agrega acá
  // también (sin quitarla de allá) para no tener que salir de
  // Cronometraje y resultados solo para revisar las fotos.
  arrayTabs.push(<Tab key="tab-RevisarFotos" label="Revisar fotos cargadas" />);
  contentTabs.push(
    <TabContainer key="contTab-RevisarFotos">
      <PhotoGalleryView eventoIndex={EventoIndex} />
    </TabContainer>
  );

  arrayTabs.push(<Tab key="tab-RealTime" label="Real Time" />);
  contentTabs.push(
    <TabContainer key="contTab-RealTime">
      <RealTimeResults
        eventResults={eventResults}
        eventDetail={eventDetail}
        puntosControl={puntosControl}
      />
    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-Anouncer" label="Anouncer" />);
  contentTabs.push(
    <TabContainer key="contTab-Anouncer">
      <Anouncer
        eventResults={eventResults}
        eventDetail={eventDetail}
        puntosControl={puntosControl}
      />
    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-KilometrosTotales" label="Kilómetros totales" />);
  contentTabs.push(
    <TabContainer key="contTab-KilometrosTotales">
      <KilometrosTotales />
    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-Clock" label="Relojes" />);
  contentTabs.push(
    <TabContainer key="contTab-Clock">
      <EventClock fontSize={250} />
    </TabContainer>
  );
  arrayTabs.push(<Tab key="tab-CustomViews" label="Vistas personalizadas" />);
  contentTabs.push(
    <TabContainer key="contTab-CustomViews">
      <CustomViewContainer />
    </TabContainer>
  );

  let element;
  if (!validateProps()) {
    element = (
      <div className="row">
        <div className="col s12 m12 l12">
          <h3>Cargando resultados...</h3>
        </div>
      </div>
    );
  } else {
    userProfile = eventUsers[userID].juezTipo;

    if (userProfile == 1) {
      // subir esto luego cuando ya esté listo ese proceso
      // arrayTabs.push(<Tab key="tab-RemoteControls" label="Controles Remotos" />);
      // contentTabs.push(<TabContainer key="contTab-RemoteControls">
      //   <h5>Configurar Controles Remotos</h5>
      // </TabContainer>)
      arrayTabs.push(<Tab key="tab-UploadData" label="Subir Data Registros" />);
      contentTabs.push(
        <TabContainer key="contTab-UploadData">
          <UploadResultsData
            eventResults={eventResults}
            eventDetail={eventDetail}
            puntosControl={puntosControl}
            eventSubEvents={eventSubEvents1}
          />
        </TabContainer>
      );
    }
    element = (
      <Container maxWidth="lg">
        <Grid container direction="row" alignItems="flex-start">
          <Grid item xs={11} sm={11}>
            <Tabs
              className="z-depth-1 red-text"
              value={value}
              scrollButtons="auto"
              variant="scrollable"
              onChange={handleChange}
            >
              {arrayTabs}
            </Tabs>
          </Grid>
          <Grid item xs={1} sm={1}>
            <DownloadResultsButton />
          </Grid>
        </Grid>
        <Suspense fallback={<TabLoading />}>{contentTabs[value]}</Suspense>
      </Container>
    );
  }

  return element;
}
